module.exports = __webpack_public_path__ + "assets/img/8程序化报备.e7a38282.jpg";